exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".badge{border-radius:3px;margin-left:3px}.badge.danger{background-color:#f44336}.badge.success{background-color:#66bb6a}button.checking{cursor:not-allowed;opacity:.5}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/quiz/question/mc/question-mc.component.css
// module id = 466
// module chunks = 1